import { IconProps } from '.';

export const ChatBotIcon = ({ className, color = 'currentColor' }: IconProps) => {
  return (
    <svg
      width='18'
      height='16'
      viewBox='0 0 18 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <mask
        id='mask0_1511_164977'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='18'
        height='16'
      >
        <path
          d='M4.34961 1.25H13.6504C15.2241 1.25021 16.4998 2.52591 16.5 4.09961V8.90039C16.4998 10.4741 15.2241 11.7498 13.6504 11.75H11.0732L10.915 11.8291L6 14.2861V11.75H4.34961C2.77591 11.7498 1.50021 10.4741 1.5 8.90039V4.09961C1.50021 2.52591 2.77591 1.25021 4.34961 1.25Z'
          stroke={color}
          strokeOpacity={1}
          strokeWidth='1.5'
        />
        <circle opacity='0.5' cx='5.5501' cy='6.4998' r='1.2' fill={color} fillOpacity={1} />
        <circle opacity='0.5' cx='9.45' cy='6.4998' r='1.2' fill={color} fillOpacity={1} />
        <path
          opacity='0.75'
          d='M13.5 4.25V8.75'
          stroke={color}
          strokeOpacity={1}
          strokeWidth='1.5'
          strokeLinecap='round'
        />
      </mask>
      <g mask='url(#mask0_1511_164977)'>
        <rect x='-1.5' y='-2.5' width='21' height='21' fill={color} fillOpacity='0.9' />
      </g>
    </svg>
  );
};
